export enum STATUS {
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILED = 'failed',
}
